import { createAPIMethod } from 'utils/generic';
import { type SuggestionData } from './model';

type GetSuggestsParams = {
	phrase: string;
	count?: string;
};

export async function getSuggests(params: GetSuggestsParams, headers?: HeadersInit) {
	if (params.phrase.length < 1) {
		return [];
	}

	return createAPIMethod<GetSuggestsParams, SuggestionData[]>({
		path: `/items/suggest`,
		method: 'GET',
		headers,
	})(params);
}
